import "@arco-design/web-react/es/Table/style";
import _Table from "@arco-design/web-react/es/Table";
import React from 'react';
import GuideLayout from '../GuideLayout';
import MermaidChart from '../MermaidChart';
import styles from '../style/index.module.less';
const financeOverviewChart = `graph TD
    A["对账确认"] --> B["创建付款单"]
    B --> C["审批"]
    C --> D["付款确认"]
    D --> E["付款完成"]
    E --> F["登记发票"]
    F --> G["查看供应商余额"]

    H["PO 外费用"] --> I["创建费用项"]
    I --> J["对方确认"]
    J --> K["纳入对账结算"]

    L["预付款"] --> M["关联采购订单"]
    M --> N["审批 & 付款"]
    N --> O["后续对账时核销"]

    style E fill:#E8F5E9,stroke:#4CAF50
    style K fill:#FFF3E0,stroke:#FF9800
    style O fill:#F3E5F5,stroke:#9C27B0`;
const paymentStatusChart = `stateDiagram-v2
    [*] --> 草稿 : 对账单自动派生
    草稿 --> 待审批 : 发布
    草稿 --> [*] : 删除
    待审批 --> 已审批 : 审批通过
    待审批 --> 已驳回 : 审批驳回
    已驳回 --> 待审批 : 修改后重新发布
    已审批 --> 已确认 : 财务确认
    已确认 --> 已完成 : 付款完成`;
const paymentStatusColumns = [{
  title: '状态',
  dataIndex: 'status'
}, {
  title: '含义',
  dataIndex: 'meaning'
}, {
  title: '可用操作',
  dataIndex: 'action'
}];
const paymentStatusData = [{
  status: '草稿',
  meaning: '对账确认后自动创建',
  action: '查看、发布、删除'
}, {
  status: '待审批',
  meaning: '已提交等待审批',
  action: '等待（可撤销）'
}, {
  status: '已审批',
  meaning: '审批通过',
  action: '确认付款'
}, {
  status: '已驳回',
  meaning: '审批退回',
  action: '修改后重新发布'
}, {
  status: '已确认',
  meaning: '财务确认待付款',
  action: '完成付款'
}, {
  status: '已完成',
  meaning: '付款完成',
  action: '只读查看'
}];
const prepaymentChart = `graph LR
    A["选择采购订单"] --> B["设置预付比例"]
    B --> C["创建预付款单"]
    C --> D["审批 & 付款"]
    D --> E["后续对账时\n自动核销预付"]`;
const expenseColumns = [{
  title: '场景',
  dataIndex: 'scene'
}, {
  title: '发起方',
  dataIndex: 'initiator'
}, {
  title: '金额方向',
  dataIndex: 'direction'
}, {
  title: '说明',
  dataIndex: 'desc'
}];
const expenseData = [{
  scene: '发货补充运费',
  initiator: '采购方',
  direction: '正（+）',
  desc: '订单价不含运费，额外补运费给供应商'
}, {
  scene: '退货罚款',
  initiator: '采购方',
  direction: '负（−）',
  desc: '供应商质量问题导致退货，扣款处罚'
}, {
  scene: '加急生产费',
  initiator: '供应商',
  direction: '正（+）',
  desc: '供应商因加急产生额外费用'
}, {
  scene: '包装补偿',
  initiator: '供应商',
  direction: '正（+）',
  desc: '特殊包装要求的额外费用'
}];
const expenseStatusChart = `stateDiagram-v2
    [*] --> 未确认 : 任一方创建
    未确认 --> 已确认 : 对方确认同意
    未确认 --> [*] : 创建方删除
    已确认 --> [*] : 纳入对账结算`;
const expenseOpsColumns = [{
  title: '操作',
  dataIndex: 'op'
}, {
  title: '采购方',
  dataIndex: 'buyer'
}, {
  title: '供应商',
  dataIndex: 'supplier'
}];
const expenseOpsData = [{
  op: '创建费用项',
  buyer: '可创建（关联发货/退货单）',
  supplier: '可创建（关联发货/退货单）'
}, {
  op: '确认费用',
  buyer: '确认供应商发起的费用',
  supplier: '确认采购方发起的费用'
}, {
  op: '删除费用',
  buyer: '仅删除自己创建的未确认费用',
  supplier: '仅删除自己创建的未确认费用'
}, {
  op: '查看费用',
  buyer: '查看本供应商的所有费用',
  supplier: '查看本供应商的所有费用'
}];
const invoiceChart = `graph LR
    A["付款单完成"] --> B["登记发票信息"]
    B --> C["发票关联付款单"]
    C --> D["供应商余额中\n跟踪应收票据"]`;
const balanceColumns = [{
  title: '字段',
  dataIndex: 'field'
}, {
  title: '含义',
  dataIndex: 'meaning'
}];
const balanceData = [{
  field: '期初应付',
  meaning: '上月未付的金额'
}, {
  field: '本期应付',
  meaning: '本月对账确认的应付（含收货 + 费用）'
}, {
  field: '本期付款',
  meaning: '本月实际支付的金额'
}, {
  field: '本期预付核销',
  meaning: '预付款在本期抵扣的金额'
}, {
  field: '期末应付',
  meaning: '期初 + 本期应付 − 本期付款 − 预付核销'
}, {
  field: '期初/期末预付',
  meaning: '预付账款余额'
}, {
  field: '应收票据',
  meaning: '已登记发票的累计金额'
}];
const supplierFinanceChart = `graph TD
    A["对账单确认"] --> B["查看费用项\n（运费/罚款等）"]
    B --> C["确认费用项"]
    C --> D["对账单金额\n已包含费用"]
    D --> E["等待采购方付款"]
    E --> F["查看付款状态"]
    F --> G["查看余额\n确认应收"]

    H["需要向采购方\n收取额外费用?"] --> I["创建费用项\n关联发货/退货单"]
    I --> J["采购方确认"]
    J --> C

    style G fill:#E8F5E9,stroke:#4CAF50
    style I fill:#FFF3E0,stroke:#FF9800`;
const sections = [{
  id: 'finance-overview',
  label: '财务全景'
}, {
  id: 'payment-status',
  label: '付款单状态流转'
}, {
  id: 'prepayment',
  label: '预付款'
}, {
  id: 'expense',
  label: '费用管理'
}, {
  id: 'invoice',
  label: '发票管理'
}, {
  id: 'balance',
  label: '供应商往来余额'
}, {
  id: 'supplier-view',
  label: '供应商视角的财务操作'
}];
export default function Finance() {
  return /*#__PURE__*/React.createElement(GuideLayout, {
    title: "\u8D22\u52A1\u2014\u2014\u4ED8\u6B3E\u3001\u6536\u6B3E\u3001\u8D39\u7528\u3001\u53D1\u7968",
    firstQuestion: "\u5BF9\u8D26\u5B8C\u4E86\uFF0C\u63A5\u4E0B\u6765\u600E\u4E48\u4ED8\u6B3E\uFF1F\u8D39\u7528\u662F\u4EC0\u4E48\uFF1F\u53D1\u7968\u600E\u4E48\u5173\u8054\uFF1F",
    sections: sections
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "finance-overview"
  }, /*#__PURE__*/React.createElement("h2", null, "\u8D22\u52A1\u5168\u666F"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: financeOverviewChart
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "payment-status"
  }, /*#__PURE__*/React.createElement("h2", null, "\u4ED8\u6B3E\u5355\u72B6\u6001\u6D41\u8F6C"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: paymentStatusChart
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-table']
  }, /*#__PURE__*/React.createElement(_Table, {
    columns: paymentStatusColumns,
    data: paymentStatusData,
    pagination: false,
    size: "default",
    border: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "prepayment"
  }, /*#__PURE__*/React.createElement("h2", null, "\u9884\u4ED8\u6B3E"), /*#__PURE__*/React.createElement("blockquote", null, "\u5BF9\u67D0\u4E9B\u4F9B\u5E94\u5546\u9700\u8981\u5148\u9884\u4ED8\u90E8\u5206\u6B3E\u9879\u3002\u9884\u4ED8\u6B3E\u5173\u8054\u91C7\u8D2D\u8BA2\u5355\uFF0C\u540E\u7EED\u5BF9\u8D26\u65F6\u81EA\u52A8\u6838\u9500\u3002"), /*#__PURE__*/React.createElement("h3", null, "\u64CD\u4F5C\u8981\u70B9"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "\u9884\u4ED8\u6B3E\u6309\u8BA2\u5355\u91D1\u989D\u7684\u767E\u5206\u6BD4\u521B\u5EFA"), /*#__PURE__*/React.createElement("li", null, "\u5BF9\u8D26\u786E\u8BA4\u540E\uFF0C\u7CFB\u7EDF\u81EA\u52A8\u4ECE\u5E94\u4ED8\u4E2D\u6263\u51CF\u5DF2\u9884\u4ED8\u91D1\u989D"), /*#__PURE__*/React.createElement("li", null, "\u5728\u4F9B\u5E94\u5546\u4F59\u989D\u8868\u4E2D\u53EF\u770B\u5230\u9884\u4ED8\u7684\u671F\u521D/\u672C\u671F/\u671F\u672B\u4F59\u989D")), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: prepaymentChart
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "expense"
  }, /*#__PURE__*/React.createElement("h2", null, "\u8D39\u7528\u7BA1\u7406\uFF08PO \u5916\u7684\u5173\u8054\u8D39\u7528\uFF09"), /*#__PURE__*/React.createElement("blockquote", null, "\u8D39\u7528\u662F\u7528\u6765\u5904\u7406\u91C7\u8D2D\u8BA2\u5355\u4E4B\u5916\u3001\u4F46\u53C8\u4E0E\u8BA2\u5355\u76F8\u5173\u7684\u989D\u5916\u6536\u652F\u3002\u91D1\u989D\u53EF\u6B63\u53EF\u8D1F\uFF0C\u6302\u5728\u53D1\u8D27/\u9000\u8D27\u73AF\u8282\u5904\u7406\u3002"), /*#__PURE__*/React.createElement("h3", null, "\u5178\u578B\u573A\u666F"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-table']
  }, /*#__PURE__*/React.createElement(_Table, {
    columns: expenseColumns,
    data: expenseData,
    pagination: false,
    size: "default",
    border: true
  })), /*#__PURE__*/React.createElement("h3", null, "\u8D39\u7528\u72B6\u6001\u6D41\u8F6C"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: expenseStatusChart
  })), /*#__PURE__*/React.createElement("h3", null, "\u4F9B\u9700\u53CC\u65B9\u64CD\u4F5C"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-table']
  }, /*#__PURE__*/React.createElement(_Table, {
    columns: expenseOpsColumns,
    data: expenseOpsData,
    pagination: false,
    size: "default",
    border: true
  })), /*#__PURE__*/React.createElement("h3", null, "\u8D39\u7528\u4E0E\u5BF9\u8D26\u7684\u5173\u7CFB"), /*#__PURE__*/React.createElement("blockquote", null, "\u8D39\u7528\u9879\u786E\u8BA4\u540E\uFF0C\u91D1\u989D\u4F1A\u7EB3\u5165\u5BF9\u8D26\u5355\u4E00\u8D77\u7ED3\u7B97\u3002\u5BF9\u8D26\u5355\u91D1\u989D = \u6536\u8D27/\u9000\u8D27\u660E\u7EC6\u91D1\u989D + \u5DF2\u786E\u8BA4\u7684\u8D39\u7528\u9879\u91D1\u989D\u3002")), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "invoice"
  }, /*#__PURE__*/React.createElement("h2", null, "\u53D1\u7968\u7BA1\u7406"), /*#__PURE__*/React.createElement("blockquote", null, "\u53D1\u7968\u5173\u8054\u4ED8\u6B3E\u5355\uFF0C\u767B\u8BB0\u540E\u4E0E\u4ED8\u6B3E\u3001\u5BF9\u8D26\u5F62\u6210\u5B8C\u6574\u8D44\u91D1\u94FE\u6761\u3002"), /*#__PURE__*/React.createElement("h3", null, "\u64CD\u4F5C\u8981\u70B9"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "\u53D1\u7968\u5FC5\u987B\u5173\u8054\u4ED8\u6B3E\u5355\u521B\u5EFA"), /*#__PURE__*/React.createElement("li", null, "\u767B\u8BB0\u53D1\u7968\u7F16\u53F7\u3001\u91D1\u989D\u3001\u7A0E\u989D"), /*#__PURE__*/React.createElement("li", null, "\u53D1\u7968\u53EF\u4FEE\u6539\uFF08\u5F55\u5165\u9519\u8BEF\u65F6\uFF09\u3001\u53EF\u5220\u9664"), /*#__PURE__*/React.createElement("li", null, "\u5728\u4F9B\u5E94\u5546\u4F59\u989D\u8868\u4E2D\u53EF\u770B\u5230\u5E94\u6536\u7968\u636E\u7684\u671F\u521D/\u672C\u671F/\u671F\u672B\u4F59\u989D")), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: invoiceChart
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "balance"
  }, /*#__PURE__*/React.createElement("h2", null, "\u4F9B\u5E94\u5546\u5F80\u6765\u4F59\u989D"), /*#__PURE__*/React.createElement("blockquote", null, "\u6309\u8D26\u671F\uFF08\u6708\uFF09\u6C47\u603B\u6BCF\u4E2A\u4F9B\u5E94\u5546\u7684\u5168\u90E8\u8D44\u91D1\u5F80\u6765\uFF0C\u4E00\u5F20\u8868\u770B\u6E05\u6B20\u591A\u5C11\u3001\u9884\u4ED8\u591A\u5C11\u3001\u53D1\u7968\u6536\u4E86\u591A\u5C11\u3002"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-table']
  }, /*#__PURE__*/React.createElement(_Table, {
    columns: balanceColumns,
    data: balanceData,
    pagination: false,
    size: "default",
    border: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "supplier-view"
  }, /*#__PURE__*/React.createElement("h2", null, "\u4F9B\u5E94\u5546\u89C6\u89D2\u7684\u8D22\u52A1\u64CD\u4F5C"), /*#__PURE__*/React.createElement("blockquote", null, "\u7AD9\u5728\u4F9B\u5E94\u5546\u89D2\u5EA6\uFF0C\u8D22\u52A1\u76F8\u5173\u64CD\u4F5C\u662F\uFF1A"), /*#__PURE__*/React.createElement("h3", null, "\u4F9B\u5E94\u5546\u64CD\u4F5C\u8981\u70B9"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u53CA\u65F6\u786E\u8BA4\u8D39\u7528\u9879"), "\u2014\u2014\u91C7\u8D2D\u65B9\u53D1\u8D77\u7684\u8D39\u7528\uFF08\u5982\u7F5A\u6B3E\uFF09\u4F1A\u76F4\u63A5\u5F71\u54CD\u4F60\u7684\u6536\u6B3E\u91D1\u989D\uFF0C\u8981\u53CA\u65F6\u67E5\u770B\u548C\u786E\u8BA4"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u4E3B\u52A8\u53D1\u8D77\u8D39\u7528"), "\u2014\u2014\u5982\u6709\u989D\u5916\u8FD0\u8D39\u3001\u52A0\u6025\u8D39\u7B49\uFF0C\u4E3B\u52A8\u521B\u5EFA\u8D39\u7528\u9879\u5173\u8054\u5230\u5BF9\u5E94\u53D1\u8D27/\u9000\u8D27\u5355"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u5173\u6CE8\u5BF9\u8D26\u5355"), "\u2014\u2014\u8D39\u7528\u786E\u8BA4\u540E\u7EB3\u5165\u5BF9\u8D26\u5355\uFF0C\u5BF9\u8D26\u91D1\u989D = \u6536\u8D27/\u9000\u8D27 + \u5DF2\u786E\u8BA4\u8D39\u7528"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u67E5\u770B\u4F59\u989D"), "\u2014\u2014\u5728\u4F59\u989D\u8868\u4E2D\u53EF\u770B\u5230\u6BCF\u6708\u7684\u5E94\u4ED8\u3001\u4ED8\u6B3E\u3001\u9884\u4ED8\u6838\u9500\u3001\u5E94\u6536\u7968\u636E\u660E\u7EC6")), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: supplierFinanceChart
  }))));
}